import {
  VSF_LOCALE_COOKIE,
  VSF_CURRENCY_COOKIE
} from '@vue-storefront/core';

export default ({
  app
  // $config
}) => {
  // 循环提取app.$viewList中的lang
  const viewList = app.$viewList || [];
  const langList = [];
  viewList?.forEach((item) => {
    if (item?.lang) {
      langList.push(item.lang);
    }
  });

  // 循环app.i18n.locales，移除掉其中code不在langList中的项
  app.i18n.locales = app.i18n.locales.filter((item) => {
    return langList.indexOf(item.code) > -1;
  });

  const locale = app.$cookies.get(VSF_LOCALE_COOKIE);
  if (locale && app.i18n) {
    app.i18n.locale = locale;
  }

  const currency = app.$cookies.get(VSF_CURRENCY_COOKIE);

  app.i18n.setNumberFormat(locale, {
    currency: {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    }
  });
};
